import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Loader from "components/UI/Loader";
import { FormatDateTimeToString } from "global/datahelper";
import Trash from "components/UI/Icons/Trash";
import { UseErrorContext } from "contexts";
import Modal from "components/UI/Modal";
import UndoVoucherLineForm from "./UndoVoucherLineForm";
import { UseOrganizationContext } from "contexts";

const Container = styled.div`
  margin-top:4rem;
  table{
    margin-top:2rem;
  }
`;

const VoucherHistory = ({ items, refresh }) => {
  const { updateError } = UseErrorContext();
  const [showModal, setShowModal] = useState(false);
  const [undoVoucherLineItemId, setUndoVoucherLineItemId] = useState(0);
  const { isCompany, isTown } = UseOrganizationContext();

  const _undo = async (id) => {
    setUndoVoucherLineItemId(id);
    setShowModal(true);
  };

  return (
    <Container> 
      {showModal && (
        <Modal title="Lijn ongedaan maken" hideActions>
          <UndoVoucherLineForm id={undoVoucherLineItemId} onClose={async () => {setShowModal(false); await refresh();}}/>
        </Modal>
      )}  
     <label>Geschiedenis</label>
     <table cellSpacing="500">
        <thead>
          <tr>            
            <th></th>
            {(isTown || isCompany) && <th></th>}
            <th>Datum</th>
            <th>Omschrijving</th>
            <th>Van</th>
            <th>Naar</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        {!items 
          ? <Loader center />
           : <> 
              {items.map((item, idx) => (            
                  <tr key={item.id + '_' + idx}>   
                    <td></td>    
                    {(isTown || isCompany) && <td>{item.organizationName}</td> }     
                    <td>{FormatDateTimeToString(item.createDate)}</td>
                    <td>{item.description}</td>
                    <td>€{item.fromPrice}</td>
                    <td>€{item.toPrice}</td>        
                    <td>
                      { item.canUndo &&
                        <div onClick={() => _undo(item.id)} className="icon-button">
                          <Trash roles={["Vouchers.Create"]}/>
                        </div>
                      }
                    </td>     
                  </tr>          
              ))}
             </>
        }
        </tbody>
      </table>
    </Container>
  );
};

export default VoucherHistory;
